<template>
<div class="the-content" v-if="display">
  <v-container
    id="dashboard-page"
    fluid grid-list-xl text-xs-center
  >
    <h1 class="page-title display-1">           
      Estadísticas desde <v-btn class="date-selector-h1-btn" title="Pulsa para cambiar fecha" @click="startDateSelector = true"> {{ formattedStartDate }}</v-btn> hasta <v-btn class="date-selector-h1-btn" title="Pulsa para cambiar fecha" @click="endDateSelector = true">{{ formattedEndDate }}</v-btn>
    </h1>
    <div style="display: none;">
    <div :style="{ backgroundColor: color, width: '100px', height: '100px' }" v-for="(color, i) in colors" :key="i"></div>
    </div>
    <vuetify-btn-toggle
      :items="statsPeriodItems"
      :selected="selectedDate"
      @on-change="onChangePeriod"
    ></vuetify-btn-toggle>
  
    <v-tooltip bottom>
      <v-btn @click="onLastPeriod()" small slot="activator">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <span>Periodo anterior</span>
    </v-tooltip>
    <v-tooltip bottom>
      <v-btn @click="onNextPeriod()" small slot="activator">
        <v-icon>keyboard_arrow_right</v-icon>
      </v-btn>
      <span>Siguiente periodo</span>
    </v-tooltip>

  </v-container>

  
    <vuetify-stats-cards :items="statuses" @on-click-card="onClickStatusCard"></vuetify-stats-cards>
  </v-container>

  <v-slide-y-transition mode="out-in">
    <v-container fluid grid-list-xl v-if="stats">
      <v-layout justify-center row wrap>
      
        <vuetify-chart-card
          :id="chartOne.id"
          :height="500"
          :display="displayCharts"
          :items="chartOne.items"
          :columns="(this.isInstaller() || this.isCommerce() || this.isManager() || this.isResponsible()) ? 'xs12' : chartOne.columns"
          :title="chartOne.title"
          :subtitle="chartOne.subtitle"
          :last-update="chartOne.lastUpdate"
          :prepend-last-update-text="prependLastUpdateText"
          :display-control-buttons="displayControlButtons"
          :trans="chartTranslations"
          @on-refresh="onRefreshCard"
        ></vuetify-chart-card>

        <vuetify-chart-card
          :id="chartTwo.id"
          :height="500"
          :display="displayCharts && (this.isSuperadmin() || this.isAdmin() || this.isInstaller())"
          :items="chartTwo.items"
          :columns="chartTwo.columns"
          :title="chartTwo.title"
          :subtitle="chartTwo.subtitle"
          :last-update="chartTwo.lastUpdate"
          :prepend-last-update-text="prependLastUpdateText"
          :display-control-buttons="displayControlButtons"
          :trans="chartTranslations"
          @on-refresh="onRefreshCard"
        ></vuetify-chart-card>

        <vuetify-chart-card
          :id="chartThree.id"
          :height="500"
          :display="displayCharts && (this.isSuperadmin() || this.isAdmin() || this.isManager() || this.isInstaller())"
          :items="chartThree.items"
          :columns="chartThree.columns"
          :title="chartThree.title"
          :subtitle="chartThree.subtitle"
          :last-update="chartThree.lastUpdate"
          :prepend-last-update-text="prependLastUpdateText"
          :display-control-buttons="displayControlButtons"
          :trans="chartTranslations"
          @on-refresh="onRefreshCard"
        ></vuetify-chart-card>

        <vuetify-chart-card
          :id="chartFour.id"
          :height="500"
          :display="displayCharts && (this.isSuperadmin() || this.isAdmin() || this.isManager() || this.isInstaller() || this.isResponsible())"
          :items="chartFour.items"
          :columns="chartFour.columns"
          :title="chartFour.title"
          :subtitle="chartFour.subtitle"
          :last-update="chartFour.lastUpdate"
          :prepend-last-update-text="prependLastUpdateText"
          :display-control-buttons="displayControlButtons"
          :trans="chartTranslations"
          @on-refresh="onRefreshCard"
        ></vuetify-chart-card>

        <vuetify-chart-card
          :id="chartFive.id"
          :height="500"
          :display="displayCharts && (this.isSuperadmin() || this.isAdmin() || this.isManager() || this.isCommerce() || this.isResponsible())"
          :items="chartFive.items"
          :columns="chartFive.columns"
          :title="chartFive.title"
          :subtitle="chartFive.subtitle"
          :last-update="chartFive.lastUpdate"
          :prepend-last-update-text="prependLastUpdateText"
          :display-control-buttons="displayControlButtons"
          :trans="chartTranslations"
          @on-refresh="onRefreshCard"
        ></vuetify-chart-card>

        <vuetify-chart-card
          :id="chartSix.id"
          :ref="chartSix.id"
          :height="500"
          :group="true"
          :display="displayCharts && (this.isSuperadmin() || this.isAdmin() || this.isInstaller())"
          :items="chartSix.items"
          :columns="chartSix.columns"
          :title="chartSix.title"
          :subtitle="chartSix.subtitle"
          :last-update="chartSix.lastUpdate"
          :prepend-last-update-text="prependLastUpdateText"
          :display-control-buttons="displayControlButtons"
          :trans="chartTranslations"
          @on-refresh="onRefreshCard"
        ></vuetify-chart-card>

        <vuetify-chart-card
          :id="chartSeven.id"
          :ref="chartSeven.id"
          :height="500"
          :group="true"
          :display="displayCharts && (this.isSuperadmin() || this.isAdmin() || this.isManager() || this.isInstaller())"
          :items="chartSeven.items"
          :columns="chartSeven.columns"
          :title="chartSeven.title"
          :subtitle="chartSeven.subtitle"
          :last-update="chartSeven.lastUpdate"
          :prepend-last-update-text="prependLastUpdateText"
          :display-control-buttons="displayControlButtons"
          :trans="chartTranslations"
          @on-refresh="onRefreshCard"
        ></vuetify-chart-card>

        <vuetify-chart-card
          :id="chartEight.id"
          :ref="chartEight.id"
          :height="500"
          :group="true"
          :display="displayCharts && (this.isSuperadmin() || this.isAdmin() || this.isManager() || this.isInstaller() || this.isResponsible())"
          :items="chartEight.items"
          :columns="chartEight.columns"
          :title="chartEight.title"
          :subtitle="chartEight.subtitle"
          :last-update="chartEight.lastUpdate"
          :prepend-last-update-text="prependLastUpdateText"
          :display-control-buttons="displayControlButtons"
          :trans="chartTranslations"
          @on-refresh="onRefreshCard"
        ></vuetify-chart-card>

        <vuetify-chart-card
          :id="chartNine.id"
          :ref="chartNine.id"
          :height="500"
          :group="true"
          :display="displayCharts && (this.isSuperadmin() || this.isAdmin() || this.isManager() || this.isCommerce() || this.isResponsible())"
          :items="chartNine.items"
          :columns="chartNine.columns"
          :title="chartNine.title"
          :subtitle="chartNine.subtitle"
          :last-update="chartNine.lastUpdate"
          :prepend-last-update-text="prependLastUpdateText"
          :display-control-buttons="displayControlButtons"
          :trans="chartTranslations"
          @on-refresh="onRefreshCard"
        ></vuetify-chart-card>

      </v-layout>
    </v-container>
  </v-slide-y-transition>

    <br><br>


    <v-btn
      class="settings-btn"
      @click="sheet = true"
      v-show="display"
      absolute
      dark
      fixed
      fab
      bottom
      right
      color="primary"
    >
      <v-icon>settings</v-icon>
    </v-btn>
    <div class="text-xs-center">
      <v-bottom-sheet class="custom-bottom-sheet" scrollable v-model="sheet">
        <div>
          <v-card class="options-card">
            <v-btn @click="sheet = !sheet" class="close" flat icon color="#757575" absolute right>
              <v-icon class="close-icon">close</v-icon>
            </v-btn>
            
            <v-container fluid grid-list-xl class="checkboxes">
              <v-layout column justify-space-between>
                <h2 class="subheader gac-header-title">             
                    Filtrar desde <v-btn class="date-selector-btn" title="Pulsa para cambiar fecha" @click="startDateSelector = true"> {{ formattedStartDate }}</v-btn> hasta <v-btn class="date-selector-btn" title="Pulsa para cambiar fecha" @click="endDateSelector = true">{{ formattedEndDate }}</v-btn>
                </h2>
                <vuetify-btn-toggle
                  :items="statsPeriodItems"
                  :selected="selectedDate"
                  @change="onChangePeriod"
                ></vuetify-btn-toggle>
              </v-layout>
            </v-container>

            <div class="filter-content">
              <v-subheader>Filtrar por estado de instalación</v-subheader>
              <v-container fluid grid-list-xl class="checkboxes">
                <v-layout column justify-space-between class="filter-layout">
                  <v-flex>
                    <v-select
                      v-model="selectedStatuses"
                      ref="selected_statuses"
                      :items="formattedSelectStatuses"
                      :menu-props="{ maxHeight: '42' }"
                      label=""
                      item-text="text"
                      item-value="code"
                      multiple
                      chips
                      @change="refreshStats()"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div class="filter-content" v-if="this.isSuperadmin() || this.isAdmin() || this.isInstaller()">
              <v-subheader>Filtrar por grupos empresariales</v-subheader>
              <v-container fluid grid-list-xl class="checkboxes">
                <v-layout column justify-space-between class="filter-layout">
                  <v-flex>
                    <v-select
                      v-model="selectedBusiness"
                      :items="business"
                      :menu-props="{ maxHeight: '42' }"
                      label=""
                      item-text="text"
                      item-value="value"
                      multiple
                      chips
                      @change="refreshStats()"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div class="filter-content" v-if="this.isSuperadmin() || this.isAdmin() || this.isManager() || this.isResponsible() || this.isInstaller()">
              <v-subheader>Filtrar por empresas</v-subheader>
              <v-container fluid grid-list-xl class="checkboxes">
                <v-layout column justify-space-between class="filter-layout">
                  <v-flex>
                    <v-select
                      v-model="selectedCompanies"
                      :items="companies"
                      :menu-props="{ maxHeight: '42' }"
                      label=""
                      item-text="text"
                      item-value="value"
                      multiple
                      chips
                      @change="refreshStats()"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div class="filter-content" v-if="this.isSuperadmin() || this.isAdmin() || this.isManager() || this.isResponsible() || this.isInstaller()">
              <v-subheader>Filtrar por comercios</v-subheader>
              <v-container fluid grid-list-xl class="checkboxes">
                <v-layout column justify-space-between class="filter-layout">
                  <v-flex>
                    <v-select
                      v-model="selectedCommerces"
                      :items="commerces"
                      :menu-props="{ maxHeight: '42' }"
                      label=""
                      item-text="text"
                      item-value="value"
                      multiple
                      chips
                      @change="refreshStats()"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div class="filter-content" v-if="this.isSuperadmin() || this.isAdmin() || this.isManager() || this.isResponsible() || this.isCommerce()">
              <v-subheader>Filtrar por instaladores</v-subheader>
              <v-container fluid grid-list-xl class="checkboxes">
                <v-layout column justify-space-between class="filter-layout">
                  <v-flex>
                    <v-select
                      v-model="selectedInstallers"
                      :items="installers"
                      :menu-props="{ maxHeight: '42' }"
                      label=""
                      item-text="text"
                      item-value="value"
                      multiple
                      chips
                      @change="refreshStats()"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>
          </v-card>
        </div>
      </v-bottom-sheet>
    </div>

    <v-dialog
      ref="start_date_selector"
      v-model="startDateSelector"
      :return-value.sync="startDate"
      lazy
      full-width
      width="290px"
    >
      <v-date-picker locale="es-es" :first-day-of-week="1" color="indigo" v-model="startDate" @input="saveDate('start')">
      </v-date-picker>
    </v-dialog>
    <v-dialog
      ref="end_date_selector"
      v-model="endDateSelector"
      :return-value.sync="endDate"
      lazy
      full-width
      width="290px"
    >
      <v-date-picker locale="es-es" :first-day-of-week="1" color="indigo" v-model="endDate" @input="saveDate('end')">
      </v-date-picker>
    </v-dialog>
</div>
</template>

<script>
  import VuetifyStatsCards from 'components/vuetify-stats-cards'
  import VuetifyBtnToggle from 'components/vuetify-btn-toggle'
  import VuetifyDatePicker from 'components/vuetify-form-creator/fields/vuetify-date-picker'
  import VuetifyChartCard from 'components/vuetify-chart-card'
  import moment from 'moment'
  import momentTimeZone from 'moment-timezone'

  export default {
    components: {
      VuetifyStatsCards,
      VuetifyBtnToggle,
      VuetifyDatePicker,
      VuetifyChartCard
    },

    data () {
      return {
        stats: [],
        display: false,
        displayCharts: false,
        sheet: false,
        displayControlButtons: true,
        prependLastUpdateText: 'Actualizado',
        startDateSelector: false,
        timeZone: momentTimeZone,
        endDateSelector: false,
        selectedDate: 'year',
        startDate: moment().toISOString().substr(0, 10),
        endDate: moment().toISOString().substr(0, 10),
        clickTimer: null,
        selectedInstallers: [],
        installers: [],
        selectedBusiness: [],
        business: [],
        selectedCompanies: [],
        companies: [],
        selectedCommerces: [],
        commerces: [],
        selectedStatuses: [],
        chartItemPos: {},
        colors: [
          'rgb(91, 216, 158, 1)',
          'rgb(242, 112, 65, 1)',
          'rgb(4, 104, 191)',
          'rgb(94, 118, 191)',
          'rgb(160, 74, 217)',
          'rgb(255, 71, 94)',
          'rgb(36, 204, 181)',
          'rgb(17, 191, 142)',
          'rgb(53, 189, 242)',
          'rgb(217, 183, 119)',
          'rgb(73, 139, 166)',
          'rgb(4, 157, 217)',
          'rgb(217, 177, 163)',
          'rgb(242, 29, 107)',
          'rgb(191, 23, 85)',
          'rgb(242, 187, 19)',
          'rgb(242, 162, 12)',
          'rgb(115, 29, 10)',
          'rgb(75, 191, 104)',
          'rgb(164, 217, 50)',
          'rgb(242, 87, 116)',
          'rgb(78, 217, 177)',
          'rgb(140, 27, 100)',
          'rgb(166, 70, 95)'
        ],
        chartTranslations: {
          legends: 'Leyendas',
          activateLabel: 'Activar',
          deactivateLabel: 'Desactivar',
          lastUpdateText: 'Actualizado',
          yAxesGridlines: 'Líneas horizontales',
          yAxesTicks: 'Etiquetas verticales',
          yAxesDrawBorder: 'Borde vertical',
          xAxesGridlines: 'Líneas verticales',
          xAxesTicks: 'Etiquetas horizontales',
          xAxesDrawBorder: 'Borde horizontal'
        },
        chartOne: {
          id: 'chartOne',
          title: 'Estados de instalaciones',
          subtitle: 'Número de instalaciones / Estados',
          columns: 'xs12 sm12 md12 lg12 x12',
          items: [
            {
              type: 'doughnut',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'statuses',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      drawTicks: false,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      display: false,
                      padding: 20
                    }
                  }]
                }
              }
            },
            {
              type: 'bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'statuses',
                legend: {
                  display: false,
                  displayOption: false
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'pie',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'statuses',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            },
            {
              type: 'horizontal-bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'statuses',
                legend: {
                  display: false,
                  displayOption: false
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'polar-area',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'statuses',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            }
          ]
        },
        chartTwo: {
          id: 'chartTwo',
          title: 'Grupos empresariales',
          subtitle: 'Número de instalaciones / Grupos empresariales',
          columns: 'xs12',
          items: [
            {
              type: 'bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'business_groups',
                legend: {
                  display: false,
                  displayOption: false
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'doughnut',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'business_groups',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      drawTicks: false,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      display: false,
                      padding: 20
                    }
                  }]
                }
              }
            },
            {
              type: 'horizontal-bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'business_groups',
                legend: {
                  display: false,
                  displayOption: false
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'pie',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'business_groups',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            },
            {
              type: 'polar-area',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'business_groups',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            }
          ]
        },
        chartThree: {
          id: 'chartThree',
          title: 'Empresas',
          subtitle: 'Número de instalaciones / Empresas',
          columns: 'xs12',
          items: [
            {
              type: 'horizontal-bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'companies',
                legend: {
                  display: false,
                  displayOption: false
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'pie',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'companies',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            },
            {
              type: 'bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'companies',
                legend: {
                  display: false,
                  displayOption: false
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'doughnut',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'companies',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      drawTicks: false,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      display: false,
                      padding: 20
                    }
                  }]
                }
              }
            },
            {
              type: 'polar-area',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'companies',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            }
          ]
        },
        chartFour: {
          id: 'chartFour',
          title: 'Comercios',
          subtitle: 'Número de instalaciones / Comercios',
          columns: 'xs12',
          items: [
            {
              type: 'bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'commerces',
                legend: {
                  display: false,
                  displayOption: false
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            },
            {
              type: 'pie',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'commerces',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            },
            {
              type: 'horizontal-bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'commerces',
                legend: {
                  display: false,
                  displayOption: false
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'doughnut',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'commerces',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      drawTicks: false,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      display: false,
                      padding: 20
                    }
                  }]
                }
              }
            },
            {
              type: 'polar-area',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'commerces',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            }
          ]
        },
        chartFive: {
          id: 'chartFive',
          title: 'Instaladores',
          subtitle: 'Número de instalaciones / Instaladores',
          columns: 'xs12',
          items: [
            {
              type: 'pie',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'installers',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            },
            {
              type: 'bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'installers',
                legend: {
                  display: false,
                  displayOption: false
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'doughnut',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'installers',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      drawTicks: false,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      display: false,
                      padding: 20
                    }
                  }]
                }
              }
            },
            {
              type: 'horizontal-bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'installers',
                legend: {
                  display: false,
                  displayOption: false
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'polar-area',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'installers',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            }
          ]
        },
        chartSix: {
          id: 'chartSix',
          title: 'Grupos empresariales',
          subtitle: 'Número de instalaciones / Periodos / Grupos empresariales',
          columns: 'xs12 sm12 md12 lg12 x12',
          items: [
            {
              type: 'line',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'business_groups_multiple',
                tooltips: {
                  bodySpacing: 8,
                  xPadding: 12,
                  mode: 'nearest',
                  intersect: 0,
                  position: 'nearest'
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                scaleOverride: true,
                scaleSteps: 10,
                scaleStepWidth: 1,
                scaleStartValue: 0,
                barShowStroke: false,
                barStrokeWidth: 1,
                barValueSpacing: 2,
                legend: {
                  display: false,
                  displayOption: false
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      padding: 20,
                      beginAtZero: true,
                      display: true
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      padding: 20,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'business_groups_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'horizontal-bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'business_groups_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'radar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'business_groups_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            }
          ]
        },
        chartSeven: {
          id: 'chartSeven',
          title: 'Empresas',
          subtitle: 'Número de instalaciones / Periodos / Empresas',
          columns: 'xs12 sm12 md12 lg12 x12',
          items: [
            {
              type: 'line',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'companies_multiple',
                tooltips: {
                  bodySpacing: 8,
                  xPadding: 12,
                  mode: 'nearest',
                  intersect: 0,
                  position: 'nearest'
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                scaleOverride: true,
                scaleSteps: 10,
                scaleStepWidth: 1,
                scaleStartValue: 0,
                barShowStroke: false,
                barStrokeWidth: 1,
                barValueSpacing: 2,
                legend: {
                  display: false,
                  displayOption: false
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                responsive: true,
                onClick: this.handle,
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      padding: 20,
                      beginAtZero: true,
                      display: true
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      padding: 20,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'companies_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'horizontal-bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'companies_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'radar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'companies_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            }
          ]
        },
        chartEight: {
          id: 'chartEight',
          title: 'Comercios',
          subtitle: 'Número de instalaciones / Periodos / Comercios',
          columns: 'xs12 sm12 md12 lg12 x12',
          items: [
            {
              type: 'line',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'commerces_multiple',
                tooltips: {
                  bodySpacing: 8,
                  xPadding: 12,
                  mode: 'nearest',
                  intersect: 0,
                  position: 'nearest'
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                scaleOverride: true,
                scaleSteps: 10,
                scaleStepWidth: 1,
                scaleStartValue: 0,
                barShowStroke: false,
                barStrokeWidth: 1,
                barValueSpacing: 2,
                legend: {
                  display: false,
                  displayOption: false
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      padding: 20,
                      beginAtZero: true,
                      display: true
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      padding: 20,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'commerces_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'horizontal-bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'commerces_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'radar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'commerces_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            }
          ]
        },
        chartNine: {
          id: 'chartNine',
          title: 'Instaladores',
          subtitle: 'Número de instalaciones / Periodos / Instaladores',
          columns: 'xs12 sm12 md12 lg12 x12',
          items: [
            {
              type: 'line',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'installers_multiple',
                tooltips: {
                  bodySpacing: 8,
                  xPadding: 12,
                  mode: 'nearest',
                  intersect: 0,
                  position: 'nearest'
                },
                layout: {
                  padding: {
                    left: 10,
                    right: 10,
                    top: 10
                  }
                },
                scaleOverride: true,
                scaleSteps: 10,
                scaleStepWidth: 1,
                scaleStartValue: 0,
                barShowStroke: false,
                barStrokeWidth: 1,
                barValueSpacing: 2,
                legend: {
                  display: false,
                  displayOption: false
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      padding: 20,
                      beginAtZero: true,
                      display: true
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      padding: 20,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'installers_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'horizontal-bar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'installers_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: true,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: true,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: true
                    }
                  }]
                }
              }
            },
            {
              type: 'radar',
              data: {
                labels: [],
                datasets: []
              },
              options: {
                ref: 'installers_multiple',
                legend: {
                  display: false,
                  displayOption: false
                },
                customLegend: {
                  display: false,
                  position: 'bottom'
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                },
                responsive: true,
                onClick: this.handle,
                events: ['mousemove', 'click'],
                onHover: this.handleHover,
                maintainAspectRatio: false,
                scales: {
                  yAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      drawTicks: false,
                      beginAtZero: true,
                      display: false,
                      padding: 20
                    }
                  }],
                  xAxes: [{
                    gridLines: {
                      display: false,
                      drawBorder: false
                    },
                    scaleLabel: {
                      display: false
                    },
                    ticks: {
                      min: 0,
                      display: false
                    }
                  }]
                }
              }
            }
          ]
        },
        globalLabels: [],
        currentPeriodId: null,
        statuses: [
          {
            ref: 'total',
            code: '200',
            value: 0,
            text: 'Total',
            icon: 'query_builder',
            color: 'rgba(96, 125, 139)',
            iconColor: 'white',
            visible: true
          },
          {
            ref: 'pending',
            code: '6',
            value: 0,
            text: 'Pendientes',
            icon: 'timer',
            color: 'rgba(63, 81, 181)',
            iconColor: 'white',
            visible: true
          },
          {
            ref: 'scheduled',
            code: '13',
            value: 0,
            text: 'Programadas',
            icon: 'alarm_add',
            color: 'rgba(33, 150, 243)',
            iconColor: 'white',
            visible: true
          },
          {
            ref: 'ongoing',
            code: '7',
            value: 0,
            text: 'En transcurso',
            icon: 'alarm',
            color: 'rgba(103, 58, 183)',
            iconColor: 'white',
            visible: true
          },
          {
            ref: 'ended-without-incidents',
            code: '10',
            value: 0,
            text: 'Terminadas sin incidencias',
            icon: 'alarm_on',
            color: 'rgba(0, 150, 136)',
            iconColor: 'white',
            visible: true
          },
          {
            ref: 'finished-with-incident',
            code: '11',
            value: 0,
            text: 'Terminadas con incidencias',
            icon: 'snooze',
            color: 'rgba(0, 137, 123)',
            iconColor: 'white',
            visible: true
          },
          {
            ref: 'not-installed',
            code: '14',
            value: 0,
            text: 'No instalada por iBEC',
            icon: 'timer_off',
            color: 'rgb(139, 195, 74)',
            iconColor: 'white',
            visible: true
          },
          {
            ref: 'postponed',
            code: '9',
            value: 0,
            text: 'Aplazadas',
            icon: 'update',
            color: 'rgba(255, 152, 0)',
            iconColor: 'white',
            visible: true
          },
          {
            ref: 'cancelled',
            code: '8',
            value: 0,
            text: 'Anuladas',
            icon: 'timer_off',
            color: 'rgba(244, 67, 54)',
            iconColor: 'white',
            visible: true
          }
        ],
        statsPeriodItems: [
          {
            text: 'Hoy',
            value: 'day'
          },
          {
            text: 'Semana',
            value: 'week'
          },
          {
            text: 'Mes',
            value: 'month'
          },
          {
            text: moment().format('YYYY'),
            value: 'year'
          },
          {
            text: 'Último año',
            value: '365'
          }
        ]
      }
    },

    mounted () {
    },

    created () {
      moment.locale('es')
      moment().tz('Europe/Madrid')
      this.startDate = moment('1983-08-04').toISOString().substr(0, 10)
      this.endDate = moment().startOf('second').toISOString().substr(0, 10)
      this.getStats().then((response) => {
        let stats = response.data
        this.setAvailableItems(stats)
        this.setAvailableStatuses(stats)
        this.onChangePeriod('year')
        this.getStats().then((response) => {
          this.setStats()
          this.display = true
          setTimeout(() => {
            this.displayCharts = true
          }, 10)
        }).catch((error) => {
          console.log(error)
        })
      }).catch((error) => {
        console.log(error)
      })
    },

    methods:
    {
      setStats (id) {
        if (this.stats) {
          this.resetStatusesCounter()
          this.stats.forEach((item, index) => {
            this.addStatus(item)
            this.setCurrentPeriodLabels()
          })
          if (!id) {
            this.initChartOne()
            this.initChartTwo()
            this.initChartThree()
            this.initChartFour()
            this.initChartFive()
            this.initChartSix()
            this.initChartSeven()
            this.initChartEight()
            this.initChartNine()
          } else if (id === 'chartOne') {
            this.initChartOne()
          } else if (id === 'chartTwo') {
            this.initChartTwo()
          } else if (id === 'chartThree') {
            this.initChartThree()
          } else if (id === 'chartFour') {
            this.initChartFour()
          } else if (id === 'chartFive') {
            this.initChartFive()
          } else if (id === 'chartSix') {
            this.initChartSix()
          } else if (id === 'chartSeven') {
            this.initChartSeven()
          } else if (id === 'chartEight') {
            this.initChartEight()
          } else if (id === 'chartNine') {
            this.initChartNine()
          }
        }
      },

      getStats () {
        return new Promise((resolve, reject) => {
          if (!moment(this.startDate).isSameOrBefore(this.endDate)) {
            this.$awn.alert('La fecha de inicio debe ser anterior o igual a la fecha de finalización.')
            this.stats = []
            return resolve(false)
          }
          console.warn('from_date', this.formattedStartDate)
          console.warn('to_date', this.formattedEndDate)
          console.warn('selectedBusiness', this.selectedBusiness.join())
          console.warn('selectedCompanies', this.selectedCompanies.join())
          console.warn('selectedCommerces', this.selectedCommerces.join())
          console.warn('selectedInstallers', this.selectedInstallers.join())
          console.warn('selectedStatuses', this.selectedStatuses.join())
          this.$store.dispatch('api/authRequest', {
            method: 'post',
            url: 'stats/',
            data: {
              from_date: this.formattedStartDate,
              to_date: this.formattedEndDate,
              selected_installers: this.selectedInstallers.join(),
              selected_commerces: this.selectedCommerces.join(),
              selected_companies: this.selectedCompanies.join(),
              selected_business: this.selectedBusiness.join(),
              selected_statuses: this.selectedStatuses.join()
            }
          }).then((response) => {
            console.log('STATS', response.data)
            this.stats = response.data
            resolve(response)
          }).catch((error) => {
            console.log(error)
            let message = this.$store.getters['api/getMessage']
            this.$awn.alert('No se han podido obtener las estadísticas: ' + message)
            reject(error.response)
          })
        })
      },

      resetStatusesCounter () {
        this.statuses.forEach((item, index) => {
          item.value = 0
        })
      },

      onNextPeriod () {
        let days = moment(this.endDate).diff(this.startDate, 'days', false)
        if (days === 364 || days === 365) {
          this.startDate = moment(this.endDate).add(2, 'day').toISOString().substr(0, 10)
          this.endDate = moment(this.endDate).add(1, 'year').add(1, 'day').toISOString().substr(0, 10)
        } else if (days > 27 && days < 32) {
          this.startDate = moment(this.endDate).add(2, 'day').toISOString().substr(0, 10)
          this.endDate = moment(this.startDate).add(1, 'month').toISOString().substr(0, 10)
        } else if (days === 6) {
          this.startDate = moment(this.endDate).add(2, 'day').toISOString().substr(0, 10)
          this.endDate = moment(this.startDate).add(1, 'week').toISOString().substr(0, 10)
        } else if (days === 0) {
          this.startDate = moment(this.endDate).add(2, 'day').toISOString().substr(0, 10)
          this.endDate = moment(this.startDate).add(1, 'day').toISOString().substr(0, 10)
        } else if (days > 0) {
          this.startDate = moment(this.endDate).add(2, 'day').toISOString().substr(0, 10)
          this.endDate = moment(this.startDate).add(days + 1, 'day').toISOString().substr(0, 10)
        }
      },

      onLastPeriod () {
        let days = moment(this.endDate).diff(this.startDate, 'days', false)
        console.log(days)
        if (days === 364 || days === 365) {
          this.startDate = moment(this.startDate).subtract(1, 'year').add(1, 'day').toISOString().substr(0, 10)
          this.endDate = moment(this.startDate).add(1, 'year').toISOString().substr(0, 10)
        } else if (days > 27 && days < 32) {
          this.startDate = moment(this.startDate).subtract(1, 'month').add(1, 'day').toISOString().substr(0, 10)
          this.endDate = moment(this.startDate).add(1, 'month').toISOString().substr(0, 10)
        } else if (days === 6) {
          this.startDate = moment(this.startDate).subtract(1, 'week').add(1, 'day').toISOString().substr(0, 10)
          this.endDate = moment(this.startDate).add(1, 'week').toISOString().substr(0, 10)
        } else if (days === 0) {
          this.startDate = moment(this.startDate).subtract(1, 'day').add(1, 'day').toISOString().substr(0, 10)
          this.endDate = moment(this.startDate).add(1, 'day').toISOString().substr(0, 10)
        } else if (days > 0) {
          this.startDate = moment(this.startDate).subtract(days, 'day').toISOString().substr(0, 10)
          this.endDate = moment(this.endDate).subtract(days, 'day').toISOString().substr(0, 10)
        }
      },

      setCurrentPeriodLabels () {
        this.globalLabels = []
        let startDate = this.startDate
        let endDate = this.endDate

        if (moment(endDate).diff(startDate, 'years', false) > 0) {
          this.currentPeriodId = 'years'
          let startMonth = moment(startDate).format('YYYY')
          let endMonth = moment(endDate).format('YYYY')
          if (startMonth !== endMonth) {
            this.globalLabels.push(moment(startDate).format('YYYY'))
            while (startMonth !== endMonth) {
              startDate = moment(startDate).add(1, 'year')
              startMonth = moment(startDate).format('YYYY')
              this.globalLabels.push(moment(startDate).format('YYYY'))
            }
          } else {
            this.globalLabels.push(startMonth)
          }
        } else if (moment(endDate).diff(startDate, 'months', false) > 0) {
          this.currentPeriodId = 'months'
          let startMonth = moment(startDate).format('YYYY-MM')
          let endMonth = moment(endDate).format('YYYY-MM')
          if (startMonth !== endMonth) {
            this.globalLabels.push(moment(startDate).format('MMMM'))
            while (startMonth !== endMonth) {
              startDate = moment(startDate).add(1, 'month')
              startMonth = moment(startDate).format('YYYY-MM')
              this.globalLabels.push(moment(startDate).format('MMMM'))
            }
          } else {
            this.globalLabels.push(startMonth)
          }
        } else if (moment(endDate).diff(startDate, 'days', false) > 6) {
          this.currentPeriodId = 'days'
          let startDay = moment(startDate).format('YYYY-MM-DD')
          let endDay = moment(endDate).format('YYYY-MM-DD')
          if (startDay !== endDay) {
            this.globalLabels.push(moment(startDate).format('DD'))
            while (startDay !== endDay) {
              startDate = moment(startDate).add(1, 'day')
              startDay = moment(startDate).format('YYYY-MM-DD')
              this.globalLabels.push(moment(startDate).format('DD'))
            }
          } else {
            this.globalLabels.push(startDay)
          }
        } else if (moment(endDate).diff(startDate, 'days', false) <= 6 && moment(endDate).diff(startDate, 'days', false) > 0) {
          this.currentPeriodId = 'week'
          let startDay = moment(startDate).format('YYYY-MM-DD')
          let endDay = moment(endDate).format('YYYY-MM-DD')
          if (startDay !== endDay) {
            this.globalLabels.push(moment(startDate).format('dddd'))
            while (startDay !== endDay) {
              startDate = moment(startDate).add(1, 'day')
              startDay = moment(startDate).format('YYYY-MM-DD')
              this.globalLabels.push(moment(startDate).format('dddd'))
            }
          } else {
            this.globalLabels.push(startDay)
          }
        } else if (moment(endDate).diff(startDate, 'hours', false) === 0) {
          this.currentPeriodId = 'hour'
          for (let i = 8; i < 24; i++) {
            this.globalLabels.push(('0' + i).slice(-2))
          }
          this.globalLabels.push('00')
        }
      },

      addStatus (item) {
        let statusId = item.status_id
        let index = this.statuses.findIndex(item => item.code === statusId.toString())
        if (index > -1) {
          this.statuses[index].value++
          this.statuses[0].value++ // total
        } else {
          this.$awn.alert('Algo fue mal al agregar los estados.')
        }
      },
      getRGBA (str, a) {
        let match = str.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/)
        let r = match[1] || 255
        let g = match[2] || 255
        let b = match[3] || 255
        a = a || match[4] || 1
        return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')'
      },

      getRGB () {
        let color = {
          r: Math.floor(Math.random() * 255),
          g: Math.floor(Math.random() * 255),
          b: Math.floor(Math.random() * 255)
        }
        return 'rgb(' + color.r + ',' + color.g + ',' + color.b + ')'
      },

      shuffleColors () {
        let currentIndex = this.colors.length
        let temporaryValue = null
        let randomIndex = null

        while (currentIndex !== 0) {
          randomIndex = Math.floor(Math.random() * currentIndex)
          currentIndex -= 1
          temporaryValue = this.colors[currentIndex]
          this.colors[currentIndex] = this.colors[randomIndex]
          this.colors[randomIndex] = temporaryValue
        }
      },

      onRefreshCard (id, item) {
        this.refreshStats(id)
      },

      initChartOne () {
        let labels = []
        let colors = []
        let data = []
        this.formattedStatuses.forEach((item, index) => {
          if (item.ref !== 'total') {
            colors.push(item.transparentColor[9])
            labels.push(item.text)
            data[index] = item.value
          }
        })

        this.chartOne.items.forEach((item) => {
          let isPie = item.type === 'doughnut' || item.type === 'pie'
          item.data = {
            labels: labels,
            datasets: [
              {
                label: '',
                data: data,
                display: false,
                backgroundColor: colors,
                borderColor: isPie ? colors : colors,
                borderWidth: isPie ? 0.5 : 0
              }
            ]
          }
        })
      },

      initChartTwo () {
        let labels = []
        let colors = []
        let data = []

        this.formattedBusiness.forEach((item, index) => {
          colors.push(item.transparentColor[7])
          labels.push(item.text)
          data[index] = 0
        })

        this.stats.forEach((item) => {
          let index = labels.findIndex((label) => label === item.business_name)
          if (index > -1) {
            data[index]++
          }
        })

        this.chartTwo.items.forEach((item) => {
          let isPie = item.type === 'doughnut' || item.type === 'pie'
          item.data = {
            labels: labels,
            datasets: [
              {
                label: '',
                data: data,
                display: false,
                backgroundColor: colors,
                borderColor: isPie ? colors : colors,
                borderWidth: isPie ? 0.5 : 0
              }
            ]
          }
        })
      },

      initChartThree () {
        let labels = []
        let colors = []
        let data = []

        this.formattedCompanies.forEach((item, index) => {
          colors.push(item.transparentColor[7])
          labels.push(item.text)
          data[index] = 0
        })

        this.stats.forEach((item) => {
          let index = labels.findIndex((label) => label === item.company_name)
          if (index > -1) {
            data[index]++
          }
        })

        this.chartThree.items.forEach((item) => {
          let isPie = item.type === 'doughnut' || item.type === 'pie'
          item.data = {
            labels: labels,
            datasets: [
              {
                label: '',
                data: data,
                display: false,
                backgroundColor: colors,
                borderColor: isPie ? colors : colors,
                borderWidth: isPie ? 0.5 : 0
              }
            ]
          }
        })
      },

      initChartFour () {
        let labels = []
        let colors = []
        let data = []
        this.formattedCommerces.forEach((item, index) => {
          colors.push(item.transparentColor[7])
          labels.push(item.text)
          data[index] = 0
        })
        this.stats.forEach((item) => {
          let index = labels.findIndex((label) => label === item.commerce_name)
          if (index > -1) {
            data[index]++
          }
        })

        this.chartFour.items.forEach((item) => {
          let isPie = item.type === 'doughnut' || item.type === 'pie'
          item.data = {
            labels: labels,
            datasets: [
              {
                label: '',
                data: data,
                display: false,
                backgroundColor: colors,
                borderWidth: isPie ? 0.5 : 0
              }
            ]
          }
        })
      },

      initChartFive () {
        let labels = []
        let colors = []
        let data = []
        this.formattedInstallers.forEach((item, index) => {
          colors.push(item.transparentColor[7])
          labels.push(item.text)
          data[index] = 0
        })
        this.stats.forEach((item) => {
          let index = labels.findIndex((label) => label === item.installer_alias)
          if (index > -1) {
            data[index]++
          }
        })

        this.chartFive.items.forEach((item) => {
          let isPie = item.type === 'doughnut' || item.type === 'pie'
          item.data = {
            labels: labels,
            datasets: [
              {
                label: '',
                data: data,
                display: false,
                backgroundColor: colors,
                borderColor: isPie ? colors : colors,
                borderWidth: isPie ? 0.5 : 0
              }
            ]
          }
        })
      },

      initChartSix () {
        this.chartSix.items.forEach((chart) => {
          let business = []
          let data = []
          this.formattedBusiness.forEach((item, businessIndex) => {
            data = []
            this.globalLabels.forEach((label, index) => { data[index] = 0 })
            if (chart.type === 'line') {
              business.push({
                label: item.text,
                data: data,
                fill: true,
                strokeColor: item.color,
                // borderDash: [businessIndex, businessIndex],
                borderColor: item.transparentColor[7],
                backgroundColor: item.transparentColor[2],
                pointBackgroundColor: item.transparentColor[7],
                pointHoverBackgroundColor: item.transparentColor[4],
                pointHoverBorderColor: item.transparentColor[9],
                pointColor: item.transparentColor[7],
                pointStrokeColor: item.color,
                pointHighlightFill: item.color,
                pointHighlightStroke: item.color,
                pointBorderWidth: 5,
                pointHoverRadius: 5,
                pointHoverBorderWidth: 1,
                pointBorderColor: item.color,
                pointHitRadius: 30,
                pointRadius: 2,
                borderWidth: 2
              })
            } else {
              business.push({
                label: item.text,
                data: data,
                borderColor: item.transparentColor[7],
                backgroundColor: item.transparentColor[7],
                borderWidth: 0
              })
            }
          })

          this.stats.forEach((item) => {
            let businessIndex = business.findIndex(
              (obj) => obj.label === item.business_name
            )
            let startDate = item.booking_installation_start_date

            let labelIndex = this.globalLabels.findIndex(
              (value) => value === this.getCurrentPeriodLabel(startDate)
            )

            business[businessIndex].data[labelIndex]++
          })

          chart.data = {
            labels: this.globalLabels,
            datasets: business
          }
        })
      },

      initChartSeven () {
        this.chartSeven.items.forEach((chart) => {
          let companies = []
          let data = []
          this.formattedCompanies.forEach((item, companyIndex) => {
            data = []
            this.globalLabels.forEach((label, index) => { data[index] = 0 })
            if (chart.type === 'line') {
              companies.push({
                label: item.text,
                data: data,
                fill: true,
                strokeColor: item.color,
                // borderDash: [companyIndex, companyIndex],
                borderColor: item.transparentColor[7],
                backgroundColor: item.transparentColor[2],
                pointBackgroundColor: item.transparentColor[7],
                pointHoverBackgroundColor: item.transparentColor[4],
                pointHoverBorderColor: item.transparentColor[9],
                pointColor: item.transparentColor[7],
                pointStrokeColor: item.color,
                pointHighlightFill: item.color,
                pointHighlightStroke: item.color,
                pointBorderWidth: 5,
                pointHoverRadius: 5,
                pointHoverBorderWidth: 1,
                pointBorderColor: item.color,
                pointHitRadius: 30,
                pointRadius: 2,
                borderWidth: 2
              })
            } else {
              companies.push({
                label: item.text,
                data: data,
                borderColor: item.transparentColor[7],
                backgroundColor: item.transparentColor[7],
                borderWidth: 0
              })
            }
          })

          this.stats.forEach((item) => {
            let companyIndex = companies.findIndex(
              (obj) => obj.label === item.company_name
            )
            let startDate = item.booking_installation_start_date

            let labelIndex = this.globalLabels.findIndex(
              (value) => value === this.getCurrentPeriodLabel(startDate)
            )

            companies[companyIndex].data[labelIndex]++
          })

          chart.data = {
            labels: this.globalLabels,
            datasets: companies
          }
        })
      },

      initChartEight () {
        this.chartEight.items.forEach((chart) => {
          let commerces = []
          let data = []
          this.formattedCommerces.forEach((item, commerceIndex) => {
            data = []
            this.globalLabels.forEach((label, index) => { data[index] = 0 })
            if (chart.type === 'line') {
              commerces.push({
                label: item.text,
                data: data,
                fill: true,
                strokeColor: item.color,
                // borderDash: [commerceIndex, commerceIndex],
                borderColor: item.transparentColor[7],
                backgroundColor: item.transparentColor[2],
                pointBackgroundColor: item.transparentColor[7],
                pointHoverBackgroundColor: item.transparentColor[4],
                pointHoverBorderColor: item.transparentColor[9],
                pointColor: item.transparentColor[7],
                pointStrokeColor: item.color,
                pointHighlightFill: item.color,
                pointHighlightStroke: item.color,
                pointBorderWidth: 5,
                pointHoverRadius: 5,
                pointHoverBorderWidth: 1,
                pointBorderColor: item.color,
                pointHitRadius: 30,
                pointRadius: 2,
                borderWidth: 2
              })
            } else {
              commerces.push({
                label: item.text,
                data: data,
                borderColor: item.transparentColor[7],
                backgroundColor: item.transparentColor[7],
                borderWidth: 0
              })
            }
          })

          this.stats.forEach((item) => {
            let commerceIndex = commerces.findIndex(
              (obj) => obj.label === item.commerce_name
            )
            let startDate = item.booking_installation_start_date

            let labelIndex = this.globalLabels.findIndex(
              (value) => value === this.getCurrentPeriodLabel(startDate)
            )

            commerces[commerceIndex].data[labelIndex]++
          })

          chart.data = {
            labels: this.globalLabels,
            datasets: commerces
          }
        })
      },

      initChartNine () {
        this.chartNine.items.forEach((chart) => {
          let installers = []
          let data = []
          this.formattedInstallers.forEach((item, installerIndex) => {
            data = []
            this.globalLabels.forEach((label, index) => { data[index] = 0 })
            if (chart.type === 'line') {
              installers.push({
                label: item.text,
                data: data,
                fill: true,
                strokeColor: item.color,
                // borderDash: [installerIndex, installerIndex],
                borderColor: item.transparentColor[7],
                backgroundColor: item.transparentColor[2],
                pointBackgroundColor: item.transparentColor[7],
                pointHoverBackgroundColor: item.transparentColor[4],
                pointHoverBorderColor: item.transparentColor[9],
                pointColor: item.transparentColor[7],
                pointStrokeColor: item.color,
                pointHighlightFill: item.color,
                pointHighlightStroke: item.color,
                pointBorderWidth: 5,
                pointHoverRadius: 5,
                pointHoverBorderWidth: 1,
                pointBorderColor: item.color,
                pointHitRadius: 30,
                pointRadius: 2,
                borderWidth: 2
              })
            } else {
              installers.push({
                label: item.text,
                data: data,
                borderColor: item.transparentColor[7],
                backgroundColor: item.transparentColor[7],
                borderWidth: 0
              })
            }
          })

          this.stats.forEach((item) => {
            let installerIndex = installers.findIndex(
              (obj) => obj.label === item.installer_alias
            )
            let startDate = item.booking_installation_start_date

            let labelIndex = this.globalLabels.findIndex(
              (value) => value === this.getCurrentPeriodLabel(startDate)
            )

            installers[installerIndex].data[labelIndex]++
          })

          chart.data = {
            labels: this.globalLabels,
            datasets: installers
          }
        })
      },

      getCurrentPeriodLabel (startDate) {
        let label = null
        switch (this.currentPeriodId) {
          case 'years':
            label = moment(startDate).format('YYYY')
            break
          case 'months':
            label = moment(startDate).format('MMMM')
            break
          case 'days':
            label = moment(startDate).format('DD')
            break
          case 'week':
            label = moment(startDate).format('dddd')
            break
          case 'hours':
            label = moment(startDate).format('HH')
            break
          default:
            break
        }
        if (!label) {
          return this.$awn.alert('Hubo un error al generar la etiqueta del periodo actual.')
        }
        return label
      },

      getColorTransparencies (color) {
        return [
          this.getRGBA(color, '0'),
          this.getRGBA(color, '0.1'),
          this.getRGBA(color, '0.2'),
          this.getRGBA(color, '0.3'),
          this.getRGBA(color, '0.4'),
          this.getRGBA(color, '0.5'),
          this.getRGBA(color, '0.6'),
          this.getRGBA(color, '0.7'),
          this.getRGBA(color, '0.8'),
          this.getRGBA(color, '0.9')
        ]
      },

      setAvailableItems (stats) {
        stats.forEach((item, index) => {
          this.setAvailable(
            parseInt(item.business_id),
            item.business_name,
            parseInt(item.company_id),
            this.business,
            this.selectedBusiness
          )
          this.setAvailable(
            parseInt(item.company_id),
            item.company_name,
            parseInt(item.commerce_id),
            this.companies,
            this.selectedCompanies
          )
          this.setAvailable(
            parseInt(item.commerce_id),
            item.commerce_name,
            null,
            this.commerces,
            this.selectedCommerces,
            item.commerce_color
          )
          this.setAvailable(
            parseInt(item.installer_id),
            item.installer_alias,
            null,
            this.installers,
            this.selectedInstallers,
            item.installer_color
          )
        })
        this.business.sort((a, b) => a.text - b.text)
        this.companies.sort((a, b) => a.text - b.text)
        this.commerces.sort((a, b) => a.text - b.text)
        this.installers.sort((a, b) => a.text - b.text)
      },

      setAvailable (parentId, parentName, childId, items, selected, color) {
        if (selected.indexOf(parentId) === -1) {
          color = color || this.getRGB()
          items.push({
            text: parentName,
            value: parentId,
            color: color,
            transparentColor: this.getColorTransparencies(color),
            childs: []
          })
          selected.push(parentId)
        }
        let i = items.findIndex(item => item.value === parentId)
        if (childId !== null && items[i] && items[i].childs.indexOf(childId) === -1) {
          items[i].childs.push(childId)
        }
      },

      handleHover (event) {
        // event.target.style.cursor = 'pointer'
      },

      handle (point, event) {
        if (!event.length) {
          return false
        }
        let item = event[0]
        console.log(event)
        let id = 0
        let ref = item._chart.config.options.ref
        let index = item._index
        let datasetIndex = item._datasetIndex

        switch (ref) {
          case 'statuses':
            id = this.statuses[index + 1].code
            this.onClickStatus(id)
            break
          case 'business_groups':
            id = this.formattedBusiness[index].value
            this.onClickBusiness(id)
            break
          case 'companies':
            id = this.formattedCompanies[index].value
            this.onClickCompany(id)
            break
          case 'commerces':
            id = this.formattedCommerces[index].value
            this.onClickCommerce(id)
            break
          case 'installers':
            id = this.formattedInstallers[index].value
            this.onClickInstaller(id)
            break
          case 'business_groups_multiple':
            id = this.formattedBusiness[datasetIndex].value
            this.onClickBusiness(id)
            break
          case 'companies_multiple':
            id = this.formattedCompanies[datasetIndex].value
            this.onClickCompany(id)
            break
          case 'commerces_multiple':
            id = this.formattedCommerces[datasetIndex].value
            this.onClickCommerce(id)
            break
          case 'installers_multiple':
            id = this.formattedInstallers[datasetIndex].value
            this.onClickInstaller(id)
            break
          default:
            break
        }
      },

      onClickStatusCard (item, index) {
        this.onClickStatus(parseInt(item.code))
      },

      onClickStatus (id) {
        window.open(this.$router.resolve(
          {
            name: 'bookings',
            query: {
              action: 'set_status',
              status_id: id,
              from_date: this.startDate,
              to_date: this.endDate
            }
          }
        ).href, '_blank')
      },

      onClickBusiness (id) {
        window.open(this.$router.resolve(
          {
            name: 'bookings',
            query: {
              action: 'set_business_group',
              business_group_id: id,
              from_date: this.startDate,
              to_date: this.endDate
            }
          }
        ).href, '_blank')
      },

      onClickCompany (id) {
        window.open(this.$router.resolve(
          {
            name: 'bookings',
            query: {
              action: 'set_company',
              company_id: id,
              from_date: this.startDate,
              to_date: this.endDate
            }
          }
        ).href, '_blank')
      },

      onClickCommerce (id) {
        window.open(this.$router.resolve(
          {
            name: 'bookings',
            query: {
              action: 'set_commerce',
              commerce_id: id,
              from_date: this.startDate,
              to_date: this.endDate
            }
          }
        ).href, '_blank')
      },

      onClickInstaller (id) {
        window.open(this.$router.resolve(
          {
            name: 'bookings',
            query: {
              action: 'set_installer',
              installer_id: id,
              from_date: this.startDate,
              to_date: this.endDate
            }
          }
        ).href, '_blank')
      },

      setAvailableStatuses (stats) {
        this.shuffleColors()
        this.statuses.forEach((item, value) => {
          item.transparentColor = this.getColorTransparencies(item.color)
          if (item.ref !== 'total') {
            this.selectedStatuses.push(item.code)
          }
        })
      },

      getUnique (array, key) {
        const unique = array.map(e => e[key])
          .map((e, i, final) => final.indexOf(e) === i && i)
          .filter(e => array[e]).map(e => array[e])

        return unique
      },

      saveDate (type) {
        if (type === 'start') {
          this.$refs.start_date_selector.save(this.startDate)
          this.endDateSelector = false
        } else {
          this.$refs.end_date_selector.save(this.endDate)
          this.startDateSelector = false
        }
        this.selectedDate = ''
        // this.selectAttendances()
        // this.$vuetify.goTo('#gac-datatable')
      },

      isSelectedStatus (value) {
        return this.selectedStatuses.indexOf(value)
      },

      onChangePeriod (period) {
        if (!period) {
          return false
        }
        this.selectedDate = period
        switch (period) {
          case 'day':
            this.startDate = moment().startOf('second').toISOString().substr(0, 10)
            this.endDate = moment().startOf('second').toISOString().substr(0, 10)
            break
          case 'week':
            this.startDate = moment().startOf('isoWeek').add(1, 'day').toISOString().substr(0, 10)
            this.endDate = moment().endOf('isoWeek').toISOString().substr(0, 10)
            break
          case 'month':
            this.startDate = moment().startOf('month').add(1, 'day').toISOString().substr(0, 10)
            this.endDate = moment().endOf('month').toISOString().substr(0, 10)
            break
          case 'year':
            this.startDate = moment().startOf('year').add(1, 'day').toISOString().substr(0, 10)
            this.endDate = moment().endOf('year').toISOString().substr(0, 10)
            break
          case '365':
            this.startDate = moment().subtract(1, 'year').add(1, 'day').toISOString().substr(0, 10)
            this.endDate = moment().startOf('second').toISOString().substr(0, 10)
            break
          default:
            break
        }
      },

      refreshStats (id) {
        if (this.display) {
          clearTimeout(this.clickTimer)
          this.clickTimer = setTimeout(() => {
            console.warn('refreshStats')
            this.getStats().then((response) => {
              this.setStats(id)
            }).catch((error) => {
              console.log(error)
            })
          }, 100)
        }
      },

      isSuperadmin () {
        return this.$store.getters['api/getUserRol'] === 'superadmin'
      },

      isAdmin () {
        return this.$store.getters['api/getUserRol'] === 'administrator'
      },

      isCommerce () {
        return this.$store.getters['api/getUserRol'] === 'commerce'
      },

      isInstaller () {
        return this.$store.getters['api/getUserRol'] === 'installer'
      },

      isManager () {
        return this.$store.getters['api/getUserRol'] === 'manager'
      },

      isResponsible () {
        return this.$store.getters['api/getUserRol'] === 'responsible'
      }
    },

    computed: {
      formattedStartDate () {
        return moment(this.startDate).format('DD-MM-YYYY')
      },
      formattedEndDate () {
        return moment(this.endDate).format('DD-MM-YYYY')
      },
      formattedSelectStatuses () {
        let statuses = []
        this.statuses.forEach((item, index) => {
          if (item.ref !== 'total') {
            statuses.push(item)
          }
        })
        return statuses
      },
      formattedStatuses () {
        let statuses = []
        this.statuses.forEach((item, index) => {
          if (item.ref !== 'total' && this.selectedStatuses.findIndex(value => value === item.code) > -1) {
            statuses.push(item)
          }
        })
        return statuses
      },
      formattedBusiness () {
        let business = []
        let selected = []
        let unique = this.getUnique(this.stats, 'business_id')
        unique.forEach((item) => {
          let id = parseInt(item.business_id)
          let index = this.business.findIndex(item => item.value === id)
          if (index > -1) {
            selected.push(id)
            business.push(this.business[index])
          }
        })
        return business
      },
      formattedCompanies () {
        let companies = []
        let selected = []
        this.getUnique(this.stats, 'company_id').forEach((item) => {
          let id = parseInt(item.company_id)
          let index = this.companies.findIndex(item => item.value === id)
          if (index > -1) {
            selected.push(id)
            companies.push(this.companies[index])
          }
        })
        return companies
      },
      formattedCommerces () {
        let commerces = []
        let selected = []
        this.getUnique(this.stats, 'commerce_id').forEach((item) => {
          let id = parseInt(item.commerce_id)
          let index = this.commerces.findIndex(item => item.value === id)
          if (index > -1) {
            selected.push(id)
            commerces.push(this.commerces[index])
          }
        })
        return commerces
      },
      formattedInstallers () {
        let installers = []
        let selected = []
        this.getUnique(this.stats, 'installer_id').forEach((item) => {
          let id = parseInt(item.installer_id)
          let index = this.installers.findIndex(item => item.value === id)
          if (index > -1) {
            selected.push(id)
            installers.push(this.installers[index])
          }
        })
        return installers
      }
    },

    watch: {
      selectedBusiness: {
        handler: function (newVal, oldVal) {
          this.selectedCompanies = []
          this.business.forEach((item) => {
            if (newVal.indexOf(item.value) !== -1) {
              item.childs.forEach((id) => {
                this.selectedCompanies.push(id)
              })
            }
          })
        },
        deep: false
      },
      selectedCompanies: {
        handler: function (newVal, oldVal) {
          this.selectedCommerces = []
          this.companies.forEach((item) => {
            if (newVal.indexOf(item.value) !== -1) {
              item.childs.forEach((id) => {
                this.selectedCommerces.push(id)
              })
            }
          })
        },
        deep: false
      },
      'sheet' (newVal, oldVal) {
        console.log(newVal)
        if (newVal) {
          document.body.style.overflow = 'hidden'
          document.body.style.position = 'fixed'
        } else {
          document.body.style.overflow = null
          document.body.style.position = null
        }
      },
      'formattedStartDate' () {
        this.refreshStats()
      },
      'formattedEndDate' () {
        this.refreshStats()
      }
    }
  }
</script>

<style lang="sass">
#dashboard-page
  .vuetify-btn-toggle
    margin-bottom: 30px
  .display-h2
    font-size: 26px !important
    margin-top: 0px
    margin-bottom: 0px
    padding: 24px

.the-content
  margin: 0 auto
  max-width: 1000px

.settings-btn
  margin-bottom: 48px

.info-icon
  cursor: pointer
  margin-left: 3px

.options-card
  padding: 30px 0px 30px 40px

.checkboxes,
  margin-left: 5px
  margin-bottom: -26px
  margin-top: -10px

.reset-btn
  margin-left: 19px

.close
  z-index: 9999999999 !important
  top: 0
  margin: 22px 7px 0 0

.checkbox-column 
  -webkit-box-align: center
  -ms-flex-align: center
  align-items: center
  display: -webkit-inline-box
  display: -ms-inline-flexbox
  display: inline-flex
  -webkit-box-flex: 0
  -ms-flex: 0 1 auto
  justify-content: center
  min-width: 180px

.close-icon
  font-size: 35px
  color: #757575 !important

.status-chip
  color: #fff !important
  height: 27px

.date-selector-h1-btn
  color: #868db1 !important
  padding: 0px
  font-size: 28px
  /* margin: 0 -9px */
  margin-top: 0px
  font-weight: 400

.date-selector-btn
  color: #868db1 !important
  padding: 0px
  font-size: 18px !important
  /* margin: 0 */
  margin-top: 2px

.headline-title
  margin-bottom: -15px
  margin-top: 10px
  text-align: center

.gac-header-title
  padding: 0 16px 0 0px !important
  margin-bottom: 9px

.date-selector-btn
  font-size: 21px


.date-selector-btn
  div
    padding: 0 7px !important

.centered
  margin: 0 auto

.container.grid-list-xl *:not(:only-child) .layout:first-child
  margin-top: 1

.bottom-sheet.dialog
  overflow-y: auto
  overflow-x: hidden

.divider
  margin: -4px 50px 20px 16px
  width: auto

.filter-content
  max-width: 800px

.filter-layout
  margin: -39px 18px -17px -24px !important

.input-group__selections
  height: 42px

.vuetify-btn-toggle
  margin-bottom: 21px !important
  margin-top: -2px !important
</style>



// WEBPACK FOOTER //
// src/pages/stats.vue